import React, {  useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";

import "../styles/gstr.scss";
import { GSTR_3B_ACCORDIAN_HEADERS } from "../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import GstAccordian from "../../common/GstAccordian";
import { GstrThreeBDataType } from "../../../../commonTypes/gstTypes";

type AppProps = {
  fetching: boolean;
  collapseAccordian: boolean;
  gstrThreeBData: GstrThreeBDataType | {};
};

const GstrThreeBTable = ({
  fetching,
  gstrThreeBData,
  collapseAccordian,
}: AppProps) => {
  let [checkingData, setCheckingData] = useState(GSTR_3B_ACCORDIAN_HEADERS);

  useEffect(() => {
    handleExpandCollapse("collapse");
  }, [collapseAccordian]);

  const handleExpandCollapse = (type: string) => {
    let iterableData = JSON.parse(JSON.stringify(checkingData));

    iterableData?.map((item: any) => {
      if (type === "expand") {
        item.isOpen = true;
      }
      if (type === "collapse") {
        item.isOpen = false;
      }
    });

    setCheckingData([...iterableData]);
  };

  return (
    <>
      <div
        className="col-md-12 mt-4"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div>
            <div>View GSTR-3B Form Below</div>
            <div className="below-header">Amount in ₹ for all tables</div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("expand")}
          >
            Expand All
          </div>
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("collapse")}
          >
            Collapse All
          </div>
        </div>
      </div>

      <GstAccordian
        data={checkingData}
        gstrThreeBData={gstrThreeBData}
        settingData={setCheckingData}
        type="gstrthreeb"
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GstrThreeBTable);
